import React, { useMemo } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import High from '@images/svgs/high-signal.svg';
import Low from '@images/svgs/low-signal.svg';
import Medium from '@images/svgs/medium-signal.svg';
import { RATING } from '@utils/data/enums';

import messages from './messages';

const PLACEHOLDER_DASH = '-' as const;

export interface RatingAtomProps {
  rating?: RATING;
  showStatusIcon?: boolean;
}

const RatingAtom = ({ rating, showStatusIcon = true }: RatingAtomProps) => {
  const intl = useIntl();
  const integrity_rating = useMemo(() => {
    switch (rating) {
      case RATING.LOW:
        return (
          <>
            {showStatusIcon && <img src={Low} alt={intl.formatMessage(messages.low)} className="mt-0.5 h-4" />}
            <div className="text-sm font-medium font-roboto text-red-600">
              <FormattedMessage {...messages.low} />
            </div>
          </>
        );
      case RATING.MEDIUM:
        return (
          <>
            {showStatusIcon && <img src={Medium} alt={intl.formatMessage(messages.medium)} className="mt-0.5 h-4" />}
            <div className="text-sm font-medium font-roboto text-amber-400">
              <FormattedMessage {...messages.medium} />
            </div>
          </>
        );
      case RATING.HIGH:
        return (
          <>
            {showStatusIcon && <img src={High} alt={intl.formatMessage(messages.high)} className="mt-0.5 h-4" />}
            <div className="text-sm font-medium font-roboto text-green-600">
              <FormattedMessage {...messages.high} />
            </div>
          </>
        );
      default:
        return <>{PLACEHOLDER_DASH}</>;
    }
  }, [rating, showStatusIcon, intl]);

  return <div className="flex gap-1">{integrity_rating}</div>;
};

export default RatingAtom;
